import template from "./bWorklogsTable.html";
import moment from "moment";

export function bWorklogsTableDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bWorklogsTableController,
    controllerAs: 'bWorklogsTable',
    bindToController: true,
    scope: {
      worklogs: "=",
      hasErpProjectsFlag: "=?"
    }
  };

  return directive;
}

class bWorklogsTableController {
  constructor($filter) {
    'ngInject';

    this.$filter = $filter;

    this.$onInit = () => {
      const durationSum = this.worklogs.reduce((accum, curr) => curr.duration.clone().add(accum), moment.duration(0));
      this.durationSumText = this.$filter("hms")(durationSum.toJSON());
    };
  }
}